import React, { useState,useEffect } from "react";
import Logo from "../../assets/img/core-img/umutuzo-logo.png";
import Fav from "../../assets/img/core-img/favorites.png";
import Search from "../../assets/img/core-img/search.png";
import Cart from "../../assets/img/core-img/cart.png";
import Order from "../../assets/img/core-img/order.svg";
import Profile from "../../assets/img/core-img/profile.svg";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useSelector,useDispatch } from "react-redux";
import {logout,reset} from '../../store/auth/authSlice'

import {logoutAction} from "../../store/auth/actions"

const Navbar = () => {
  const dispatch = useDispatch<any>()

  const {user} = useSelector(
      (state:any) => state.auth)
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;
  console.log("current route:",currentRoute);
  const [open, setOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const handleDropDown = () => setOpenMenu(!openMenu);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width: 800px)");
  // const [currentRoute,setSelectedMenuItem] = useState('Home');
  // const [activeMenu,setActiveMenu] = useState(true);
  const storedCartData = localStorage.getItem("cart");
  const cartItems = storedCartData ? JSON.parse(storedCartData) : [];
  

  const totalQnty = cartItems
    ?.map((data: any) => data?.quantity)
    ?.reduce((total: number, quantity: number) => (total += quantity), 0);


    
    // useEffect(() => {
    //   if(!auth?.token){
    //       setFullName(auth?.user?.names);
    //       setEmail(auth?.user?.email);
    //       setAddress(auth?.user?.address);
    //       setPhoneNumber(auth?.user?.phone);
  
  
   
    //   }
  
    //  },[auth?.token])
  const handleOpenMenuClick = () => {
    setOpenMenu(true)

  }
  const handleCloseMenuClick = () => {
    setOpenMenu(false)
   

  }
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleLogout= () => {
    dispatch(logout())
    dispatch(reset())
    navigate('/')
    // logoutAction()(dispatch)
    // navigate("/")
  
  };

  console.log("rendered");
  return (
    <>
    <div className="mobile-nav">
        <div className="amado-navbar-brand">
            <a href="index.html"><img src={Logo} alt=""/></a>
        </div>
        
        <div style={{display:'flex', flexDirection:'row'}}>
          <div style={{marginRight: 20}}>
          
           <Link to={"/cart"} style={{ textDecoration: 'none' }} className={(currentRoute === "/cart")  ? "cart-nav active" : "cart-nav"} ><img src={Cart} alt=""/> Cart <span>{`(${totalQnty})`}</span></Link>
  
          </div>
          <div className="amado-navbar-toggler" onClick={handleOpenMenuClick}>
            <span></span><span></span><span></span>
            </div>
        </div>
    </div>
 
<header className={!openMenu ? "header-area clearfix" : "header-area clearfix bp-xs-on"}>
        <div className="nav-close" onClick={handleCloseMenuClick}>
            <i className="fa fa-close" aria-hidden="true"></i>
        </div>
        <div className="logo">
          <Link to={"/"} style={{ textDecoration: 'none' }}>
            <img src={Logo} alt=""/>
          </Link>
        </div>
        <nav className="amado-nav">
            <ul>
                <li className={(currentRoute === "/") ? "active" : " "} ><Link to={"/"} style={{ textDecoration: 'none' }}>Home</Link></li>
                <li className={(currentRoute === "/shop") ? "active" : " "} ><Link to={"/shop"} style={{ textDecoration: 'none' }}>Shop</Link></li>
               
            </ul>
        </nav>
        <div className="amado-btn-group mt-30 mb-100">
            {/* <a href="#" className="btn amado-btn mb-15">%Discount%</a>
            <a href="#" className="btn amado-btn active">New this week</a> */}
        </div>
        <div className="cart-fav-search mb-100">
        <Link to={"/cart"} style={{ textDecoration: 'none' }} className={(currentRoute === "/cart")  ? "cart-nav active" : "cart-nav"} ><img src={Cart} alt=""/> Cart <span>{`(${totalQnty})`}</span></Link>
        { user ? 

        (
        <>
          <Link to={"/orders"} style={{ textDecoration: 'none' }} className={(currentRoute === "/orders")  ? "fav-nav active" : "fav-nav"} ><img src={Order} alt=""/> Orders</Link>
          <Link to={"/profile"} style={{ textDecoration: 'none' }} className={(currentRoute === "/profile")  ? "searchav-nav active" : "search-nav"}  ><img src={Profile} alt=""/>Profile</Link>

          <a href="#" className="search-nav" onClick={() => handleLogout()}> Logout</a>
        </>
        ) : 
        (  <>
          <Link to={"/login"} style={{ textDecoration: 'none' }} className={(currentRoute === "/login")  ? "searchav-nav active" : "search-nav"}  > Login</Link>
          <Link to={"/register"} style={{ textDecoration: 'none' }} className={(currentRoute === "/register")  ? "searchav-nav active" : "search-nav"}  > Register</Link>
          </>
        )
        }
        </div>
        <div className="social-info d-flex justify-content-between">
            <a href="#"><i className="fa fa-pinterest" aria-hidden="true"></i></a>
            <a href="#"><i className="fa fa-instagram" aria-hidden="true"></i></a>
            <a href="#"><i className="fa fa-facebook" aria-hidden="true"></i></a>
            <a href="#"><i className="fa fa-twitter" aria-hidden="true"></i></a>
        </div>
    </header>
    </>
  );
};

export default Navbar;
